import React from "react";

const ChecklistSelect = ({ label, required, name, value, selectOptions, defaultOption, onChange }) => (
  <div className="checklist-select">
    {label && (
      <label htmlFor={name}>
        {label}
        {required && "*"}
      </label>
    )}
    <select name={name} value={value} onChange={onChange} required={required}>
      <option key="default" value="" disabled>
        {defaultOption}
      </option>
      {selectOptions.map((option) => (
        <option key={option}>{option}</option>
      ))}
    </select>
  </div>
);

export default ChecklistSelect;
